module.exports = __webpack_public_path__ + "static/8(3)-91bfa936384f6e2db02cbe2e24bd535b.jpg";